<template>
  <itisFooter v-bind="$attrs">
    <template #logo>
      <img
        class="logo"
        src="@/distributions/consumer/y/assets/itis-logo-2.png"
        alt=""
      />
    </template>
    <div class="contact-message">
      <div class="company">{{ t("shell.itisFooter.company") }}</div>
      <div class="address">{{ t("shell.itisFooter.address") }}</div>
      <div class="contact-type">
        <span class="telephone">{{ t("shell.itisFooter.telephone") }}</span>
        <span class="email">
          {{ t("shell.itisFooter.email", { email: "Service@itis.com.tw" }) }}
        </span>
      </div>
    </div>
    <div class="contact-list">
      <span>{{ t("shell.footer.contact") }}:</span>
      <div class="contact-list-content">
        <div
          v-for="(item, index) in linkList"
          :key="index"
          class="contact-list-item"
        >
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            <img :src="item.img" alt="" />
          </a>
        </div>
      </div>
    </div>
    <my-drawer
      v-model="showDrawer"
      :title="drawerTitle"
      :content="drawerContent"
    />
    <template #bottom>
      <div class="footer-bottom">
        <div class="bottom-tips">
          <a class="text-tips" @click="handleTermsAndConditions">{{
            $t("shared.auth.termsAndConditions")
          }}</a>
          <a class="text-tips" @click="handlePrivacyStatement">{{
            $t("shared.auth.privacyStatement")
          }}</a>
        </div>
      </div>
    </template>
  </itisFooter>
</template>

<script setup lang="ts" name="Footer">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import { getArticleDetail } from "@/api/rest/common";
import MyDrawer from "@/distributions/consumer/y/components/Drawer/index.vue";
import itisFooter from "@/distributions/consumer/y/layout/components/Footer.vue";
import {
  getUserAgreement,
  getUserPrivacy
} from "@/distributions/consumer/y/shared/constant";
import { requireIconImg } from "@/distributions/consumer/y/utils/image";

const showDrawer = ref(false);
const drawerTitle = ref("");
const drawerContent = ref("");
const { t } = useI18n();
const linkList = ref([
  {
    url: "https://www.youtube.com/channel/UC1nl4oCzr1W9cJxSso0yl0Q",
    img: requireIconImg("youtube.png")
  },
  {
    url: "https://www.facebook.com/luxuryITIS/",
    img: requireIconImg("FB.png")
  },
  {
    url: "https://www.instagram.com/luxury_itis/",
    img: requireIconImg("ins.png")
  },
  {
    url: "https://line.me/R/ti/p/%40luxuryitis",
    img: requireIconImg("line.png")
  }
]);

async function getUserPrivacyContent() {
  const userPrivacy = getUserPrivacy();
  const res = await getArticleDetail(userPrivacy);
  return res;
}

async function getUserAgreementContent() {
  const userAgreement = getUserAgreement();
  const res = await getArticleDetail(userAgreement);
  return res;
}

async function handlePrivacyStatement() {
  showDrawer.value = true;
  const res = await getUserPrivacyContent();

  drawerTitle.value = res.title;
  drawerContent.value = res.content;
}

async function handleTermsAndConditions() {
  showDrawer.value = true;
  const res = await getUserAgreementContent();

  drawerTitle.value = res.title;
  drawerContent.value = res.content;
}
</script>

<style lang="scss" scoped>
.contact-message {
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  .company {
    color: #fff;
    font-size: 14px;
  }
  .contact-type {
    display: flex;
    column-gap: 28px;
  }
}
.logo {
  width: 119px;
  height: 56px;
}
.contact-list {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  .contact-list-content {
    display: flex;
    column-gap: 12px;
  }
  span {
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    margin-right: 10px;
    text-transform: uppercase;
  }
  .contact-list-item {
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
  }
  img {
    width: 20px;
    height: 20px;

    box-sizing: content-box;
  }
}
:deep() {
  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(238, 238, 238, 0.1);
  }
}
.footer-bottom {
  margin-top: 20px;
  .bottom-tips {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 48px;
    a {
      text-decoration: underline;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
    }
  }
}
</style>
